/**
 * @file Draw-styles.ts
 * @module MapMarkerDrawStyles
 * @description Zīmēšanas stilu definīcijas Karšu pārlūka marķieru rīkam.
 *              Nodrošina OpenLayers stilu ģenerēšanu punktu, līniju un daudzstūru
 *              ģeometrijām, ieskaitot apvedceļu (detour) un izcēluma (highlight) stilus.
 *              Stili tiek izmantoti gan zīmēšanas interakcijā, gan marķieru attēlošanā.
 */
import { Feature } from "ol";
import { Circle, Fill, Stroke, Style } from "ol/style.js";
import { addEndsToLineString } from "../../data-layers/Style-generator-turf";
import { MultiLineString } from "ol/geom";

const blue = "#0000ff";
const width = 3;

export const getDrawStyle = (feature?: any, r?: number, colour?: string) => {
	if (feature?.get("detour")) {
		colour = "rgb(204, 140, 0)";
	}

	let styles = [
		new Style({
			stroke: new Stroke({
				color: feature?.get("detour") ? "#000000" : "#ffffff",
				width: width + 2,
				lineCap: "butt",
			}),
		}),
		new Style({
			fill: new Fill({
				color: [255, 255, 255, 0.3],
			}),
			stroke: new Stroke({
				color: colour ?? blue,
				width: width,
				lineCap: "butt",
			}),
		}),
		new Style({
			image: new Circle({
				radius: width * 2,
				stroke: new Stroke({
					color: colour ?? blue,
					width: width,
				}),
			}),
			zIndex: Infinity,
		}),
	];

	if (r && feature?.getGeometry()?.getType() === "MultiLineString") {
		const ends = (feature.getGeometry() as MultiLineString)
			.getLineStrings()
			.map((l) => {
				l.setCoordinates(l.getCoordinates().map((coord) => coord.filter((c, i) => i === 0 || i === 1)));
				return addEndsToLineString(
					new Feature({
						geometry: l,
						detour: feature.get("detour"),
						properties: {
							detour: feature.get("detour"),
						},
					}),
					{ color: colour ?? blue, width: width } as any,
					20 * r > 300 ? 300 : 20 * r
				);
			})
			.flat();
		styles = [ends, ...styles].flat();
	}
	return styles;
};

export const getHighlightStyle = (feature?: any, r?: number, colour?: string) => {
	const width = 5;

	if (feature?.get("detour")) {
		colour = "rgb(204, 140, 0)";
	}

	let styles = [
		new Style({
			stroke: new Stroke({
				color: feature?.get("detour") ? "#000000" : "#ffffff",
				width: width + 2,
				lineCap: "butt",
			}),
		}),
		new Style({
			fill: new Fill({
				color: [255, 255, 255, 0.3],
			}),
			stroke: new Stroke({
				color: colour ?? blue,
				width: width,
				lineCap: "butt",
			}),
		}),
		new Style({
			image: new Circle({
				radius: width,
				stroke: new Stroke({
					color: colour ?? blue,
					width: width,
				}),
				fill: new Fill({ color: colour ?? blue }),
			}),
			zIndex: Infinity,
		}),
	];

	if (r && feature?.getGeometry()?.getType() === "MultiLineString") {
		const ends = (feature.getGeometry() as MultiLineString)
			.getLineStrings()
			.map((l) => {
				l.setCoordinates(l.getCoordinates().map((coord) => coord.filter((c, i) => i === 0 || i === 1)));
				return addEndsToLineString(
					new Feature({
						geometry: l,
						detour: feature.get("detour"),
						properties: {
							detour: feature.get("detour"),
						},
					}),
					{ color: colour ?? blue, width: width } as any,
					20 * r > 300 ? 300 : 20 * r
				);
			})
			.flat();
		styles = [ends, ...styles].flat();
	}
	return styles;
};
